<template>
    <transition-component>
        <keep-alive :include="cachedRoutes" :max="keepAliveMaxNum">
            <router-view/>
        </keep-alive>
    </transition-component>
</template>

<script>
    import {eventBus} from "@zhoujianhui/vip-core";
    import {mapGetters} from "vuex"
    import TransitionComponent from '../component/TransitionComponent'
    // import enterpriseManager from "../../enterprise/enterprise-manager";

    export default {
        name: "AppMain",
        components: {
            TransitionComponent
        },
        data() {
            return {
                // 默认路由缓存最大数量
                keepAliveMaxNum: 100,
                // 企业认证弹窗显示
                showEnterpriseAutnenticate: false
            }
        },
        computed: {
            ...mapGetters({
                transitionName: "app-theme/transitionName",
                cachedRoutes: "app-theme/cachedRoutes",
                cachedRoutesHistory: "app-theme/cachedRoutesHistory"
            })
        },

        methods: {
            /**
             * Description 页面初始化时监听路由,未认证企业不能进入需要企业认证权限的路由,此处主要靠前端拦截
             * Date 2022/5/10
             */
            bindShowEnterpriseAutnenticate() {
                eventBus.$on('isRequiredEnterpriseAuth', () => {
                    this.showEnterpriseAutnenticate = true;
                })
            }
        }
    }
</script>
